import store from "@/store";
import commonConstants, { lang } from "@/constants/commonConstants";
import { Message } from "element-ui";
import i18n from "@/components/common/i18n";
import _ from "lodash";
import { Decimal } from "decimal.js";
export default {
    isEmpty(obj) {
        if (obj == undefined || obj == null) {
            return true;
        } else if (typeof obj != "object") {
            if (typeof obj == "string") {
                return obj.trim() == "";
            }
            return obj == null;
        } else if (JSON.stringify(obj) == "{}") {
            return true;
        } else if (Array.isArray(obj)) {
            return obj.length == 0;
        } else if (JSON.stringify(obj) == "[]") {
            return true;
        }
    },
    blobToFile(resp) { },
    isNotEmpty(obj) {
        return !this.isEmpty(obj);
    },
    convertToArray(obj) {
        return this.isEmpty(obj) ? [] : Array.isArray(obj) ? obj : [obj];
    },
    stringConvertToArray(obj, splitStr) {
        return this.isEmpty(obj) ? [] : obj.split(splitStr);
    },
    getICVal(tableName, fieldName, code) {
        try {
            let ic = store.state.main.inputChoiceDec[tableName][fieldName][code];
            if (!this.isEmpty(ic)) {
                let userWorkLanguage = store.getters.userWorkLanguage;
                if (userWorkLanguage == lang.EN) {
                    return ic.englishValue;
                } else {
                    return ic.chineseValue;
                }
            }
        } catch (e) {
            console.log(e);
        }
        return null;
    },
    listIC(tableName, fieldName) {
        try {
            let inputChoiceDec = store.state.main.inputChoiceDec;
            if (!inputChoiceDec.hasOwnProperty(tableName) ||
                !inputChoiceDec[tableName].hasOwnProperty(fieldName)
            ) {
                return null;
            }
            let ics = inputChoiceDec[tableName][fieldName];
            if (!this.isEmpty(ics)) {
                let userWorkLanguage = store.getters.userWorkLanguage;
                let keys = Object.keys(ics);
                let res = {};
                for (let key of keys) {
                    let ic = ics[key];
                    ic.code = key;
                    if (userWorkLanguage == lang.EN) {
                        ic.value = ic.englishValue;
                    } else {
                        ic.value = ic.chineseValue;
                    }
                    res[key] = ic;
                }
                return res;
            }
        } catch (e) {
            console.error(e);
        }
        return null;
    },
    convertToIcMap(icList) {
        let icData = {};
        icList.forEach((ic) => {
            icData[ic.code] = ic.chineseValue;
        });
        return icData;
    },
    isSupplier() {
        return localStorage.getItem("ms_emplFlag") == "SUP";
    },
    havePermission(permission) {
        let functions = localStorage.getItem("ms_Permission");
        return functions.indexOf(permission) >= 0;
    },
    remove(array, item, equalFun) {
        array = array.filter((obj) => equalFun(obj, item));
        return array;
    },
    unicodeLength(str) {
        if (undefined == str) return 0;
        let l = 0,
            i = 0;
        for (i = 0; i < str.length; i++) {
            if (str.charCodeAt(i) > 255) l += 3;
            else l++;
        }
        return l;
    },
    distinct(arr, keyFun) {
        let obj = {};
        let newArr = [];
        if (this.isNotEmpty(arr)) {
            arr.forEach((item) => {
                if (!obj[keyFun(item)]) {
                    obj[keyFun(item)] = 1;
                    newArr.push(item);
                }
            });
        }
        return newArr;
    },
    trim(str, char, type) {
        if (!str) {
            return str;
        }
        if (char) {
            if (type == "left") {
                return str.replace(new RegExp("^\\" + char + "+", "g"), "");
            } else if (type == "right") {
                return str.replace(new RegExp("\\" + char + "+$", "g"), "");
            }
            return str.replace(
                new RegExp("^\\" + char + "+|\\" + char + "+$", "g"),
                ""
            );
        }
        return str.replace(/^\s+|\s+$/g, "");
    },
    deepCopy(obj) {
        return JSON.parse(JSON.stringify(obj));
    },
    toChinesNum: (num) => {
        if (null == num || isNaN(num)) {
            return num;
        }
        let changeNum = [
            "零",
            "一",
            "二",
            "三",
            "四",
            "五",
            "六",
            "七",
            "八",
            "九",
        ];
        let unit = ["", "十", "百", "千", "万"];
        num = parseInt(num);
        let getWan = (temp) => {
            let strArr = temp
                .toString()
                .split("")
                .reverse();
            let newNum = "";
            for (var i = 0; i < strArr.length; i++) {
                newNum =
                    (i == 0 && strArr[i] == 0 ?
                        "" :
                        i > 0 && strArr[i] == 0 && strArr[i - 1] == 0 ?
                            "" :
                            changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i])) +
                    newNum;
            }
            return newNum;
        };
        let overWan = Math.floor(num / 10000);
        let noWan = num % 10000;
        if (noWan.toString().length < 4) {
            noWan = "0" + noWan;
        }
        return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
    },
    toRomanNum(num) {
        if (null == num || isNaN(num)) {
            return num;
        }
        var a = [
            ["", "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX"],
            ["", "X", "XX", "XXX", "XL", "L", "LX", "LXX", "LXXX", "XC"],
            ["", "C", "CC", "CCC", "CD", "D", "DC", "DCC", "DCCC", "CM"],
            ["", "M", "MM", "MMM"],
        ];
        var i = a[3][Math.floor(num / 1000)];
        var j = a[2][Math.floor((num % 1000) / 100)];
        var k = a[1][Math.floor((num % 100) / 10)];
        var l = a[0][num % 10];
        return i + j + k + l;
    },
    validForm(data, rules, page) {
        if (this.isNotEmpty(data)) {
            let err = { msg: null, index: null };
            data.forEach((row, index) => {
                for (let rulesKey in rules) {
                    let validator = rules[rulesKey][0].validator;
                    if (validator == null) {
                        validator = (rule, value, callBack) => {
                            if (this.isEmpty(value)) {
                                callBack(new Error(""));
                            }
                        };
                    }
                    validator({
                        field: `quotationLineTableData.${index}.${rulesKey}`,
                    },
                        row[rulesKey],
                        (error) => {
                            if (err.msg == null && error != null) {
                                err.msg = error.message ?
                                    error.message :
                                    rules[rulesKey][0].message;
                                err.index = index;
                            } else {
                                return;
                            }
                        }
                    );
                }
            });
            if (err.msg != null) {
                if (page) {
                    Message.error(`${page}-line ${err.index + 1}: ${err.msg}`);
                } else {
                    Message.error(`line ${err.index + 1}: ${err.msg}`);
                }
                return false;
            }
        }
        return true;
    },
    // 乘法精确度缺失问题
    mul(...args) {
        let result = new Decimal(args[0]);
        for (let i = 1; i < args.length; i++) {
            result = result.mul(new Decimal(args[i]));
        }
        return result.toNumber();
    },
    // 加法精确度缺失问题
    add(args) {
        console.log("🚀 ~ file: common.js:141 ~ add ~ args", args)
        let result = new Decimal(args[0]);
        for (let i = 1; i < args.length; i++) {
            result = result.add(new Decimal(args[i]));
        }
        return result.toNumber();
    },
    // 减法精确度缺失问题
    sub(...args) {
        console.log("🚀 ~ file: commonFun.js:252 ~ sub ~ args", args)
        let result = new Decimal(args[0]);
        console.log("🚀 ~ file: commonFun.js:254 ~ sub ~ result", result)
        for (let i = 1; i < args.length; i++) {
            result = result.sub(new Decimal(args[i]));
        }
        console.log('1111', result);
        return result.toNumber();
    },
    // 除法精确度缺失问题
    div(...args) {
        let result = new Decimal(args[0]);
        for (let i = 1; i < args.length; i++) {
            result = result.div(new Decimal(args[i]));
        }
        return result.toNumber();
    },
    // 只能输入正数和0,且限定保留几位小数
    formatPositiveNumber(e, digit1) {
        console.log("GY🚀 ~ file: commonFun.js:271 ~ formatPositiveNumber ~ e:", e);
        let value = e.replace(/[^\d.]/g, '') // 只能输入数字和.
        value = value.replace(/^\./g, '') //第一个字符不能是.
        value = value.replace(/\.{2,}/g, '.') // 不能连续输入.
        value = value.replace(/(\.\d+)\./g, '$1') // .后面不能再输入.
        value = value.replace(/^0+(\d)/, '$1') // 第一位0开头，0后面为数字，则过滤掉，取后面的数字
        // if (digit1 === 10) {
        //     value = value.replace(/(\d{10})\d*/, '$1') // 最多保留10位整数
        // }
        if (digit1 === 2) {
            value = value.replace(/(\.\d{2})\d*/, '$1') // 最多保留2位小数
        }
        return value
    },
    //涉及到钱的自动补零
    getFloatStr(input, n) {
        // 处理空值
        if (input === "" || input === ".") return n > 0 ? `0.${'0'.repeat(n)}` : '0';
        let str = input.toString();
        // 处理 .123 开头的数字
        if (str.startsWith('.')) {
            str = `0${str}`;
        }
        console.log("GY🚀 ~ getFloatStr ~ str:", str);

        // 拆分整数和小数部分
        let [integerPart, decimalPart = ''] = str.split('.');
        integerPart = integerPart || '0'; // 处理空整数部分
        console.log("GY🚀 ~ getFloatStr ~ integerPart:", integerPart);

        // 处理纯整数
        if (!str.includes('.')) {
            return n > 0 ? `${integerPart}.${'0'.repeat(n)}` : integerPart;
        }
        // 处理小数部分
        decimalPart = decimalPart.slice(0, n); // 截断超长部分
        decimalPart = decimalPart.padEnd(n, '0'); // 不足补零

        // 组合最终结果
        return n > 0 ? `${integerPart}.${decimalPart}` : integerPart;
    },
    // 获取某个日期前/后N天/周/月/年前的日期
    getDate(date, type = null, number = 0, before = null, after = null) {
        // console.log("GY🚀 ~ file: common.js:254 ~ getDate ~ after:", after);
        // console.log("GY🚀 ~ file: common.js:254 ~ getDate ~ before:", before);
        // console.log("GY🚀 ~ file: common.js:254 ~ getDate ~ number:", number);
        // console.log("GY🚀 ~ file: common.js:254 ~ getDate ~ type:", type);
        // console.log("GY🚀 ~ file: common.js:254 ~ getDate ~ date:", date);
        var nowDate
        if (date) {
            nowDate = new Date(date);
        } else {
            nowDate = new Date()
        }
        switch (type) {
            case "day": //取number天前、后的时间
                if (before) {
                    nowDate.setTime(nowDate.getTime() - (24 * 3600 * 1000) * number);
                }
                if (after) {
                    nowDate.setTime(nowDate.getTime() + (24 * 3600 * 1000) * number);
                }
                var y = nowDate.getFullYear();
                var m = nowDate.getMonth() + 1;
                m = m < 10 ? '0' + m : m
                var d = nowDate.getDate();
                d = d < 10 ? '0' + d : d
                var returnDate = y + '-' + m + '-' + d;
                console.log("🚀 ~ file: commonFun.js:99 ~ 取number天前、后的时间 ~ returnDate:", returnDate)
                break;
            case "week": //取number周前、后的时间
                var weekDate
                if (before) {
                    weekDate = new Date(nowDate.getTime() - (7 * 24 * 3600 * 1000) * number);
                }
                if (after) {
                    weekDate = new Date(nowDate.getTime() + (7 * 24 * 3600 * 1000) * number);
                }
                var y = weekDate.getFullYear();
                var m = weekDate.getMonth() + 1;
                m = m < 10 ? '0' + m : m
                var d = weekDate.getDate();
                d = d < 10 ? '0' + d : d

                var returnDate = y + '/' + m + '/' + d;
                console.log("🚀 ~ file: commonFun.js:109 ~ 取number周前、后的时间 ~ returnDate:", returnDate)
                break;
            case "month": //取number月前、后的时间
                if (before) {
                    nowDate.setMonth(nowDate.getMonth() - number);
                }
                if (after) {
                    nowDate.setMonth(nowDate.getMonth() + number);
                }
                var y = nowDate.getFullYear();
                var m = nowDate.getMonth() + 1;
                m = m < 10 ? '0' + m : m
                var d = nowDate.getDate();
                d = d < 10 ? '0' + d : d
                var returnDate = y + '-' + m + '-' + d;
                console.log("🚀 ~ file: commonFun.js:117 ~ 取number月前、后的时间 ~ returnDate:", returnDate)
                break;
            case "year": //取number年前、后的时间
                if (before) {
                    nowDate.setFullYear(nowDate.getFullYear() + number);
                }
                if (after) {
                    nowDate.setFullYear(nowDate.getFullYear() + number);
                }
                var y = nowDate.getFullYear();
                var m = nowDate.getMonth() + 1;
                m = m < 10 ? '0' + m : m
                var d = nowDate.getDate();
                d = d < 10 ? '0' + d : d
                var returnDate = y + '-' + m + '-' + d;
                console.log("🚀 ~ file: commonFun.js:125 ~ 取number年前、后的时间 ~ returnDate:", returnDate)
                break;
            default: //取当前时间
                var y = nowDate.getFullYear();
                var m = nowDate.getMonth() + 1;
                m = m < 10 ? '0' + m : m
                var d = nowDate.getDate();
                d = d < 10 ? '0' + d : d
                var returnDate = y + '-' + m + '-' + d;
                console.log("🚀 ~ file: commonFun.js:132 ~ 取当前时间 ~ returnDate:", returnDate)
        }
        return returnDate;
    },
};